var map = {
	"./ai1.png": 20920,
	"./beard01.png": 35077,
	"./beard02.png": 55152,
	"./beard03.png": 55594,
	"./beard04.png": 42854,
	"./beard05.png": 81685,
	"./body/acolyte/bhand1.png": 40521,
	"./body/acolyte/bhand2.png": 3816,
	"./body/acolyte/body.png": 28086,
	"./body/acolyte/fhand1.png": 20556,
	"./body/acolyte/fhand2.png": 2918,
	"./body/acolyte/leg1.png": 93663,
	"./body/acolyte/leg2.png": 97403,
	"./body/acolyte/leg3.png": 23610,
	"./body/acolyte/leg4.png": 96064,
	"./body/archer/bhand1.png": 66421,
	"./body/archer/bhand2.png": 96044,
	"./body/archer/body.png": 52210,
	"./body/archer/fhand1.png": 48651,
	"./body/archer/fhand2.png": 66558,
	"./body/archer/leg1.png": 59037,
	"./body/archer/leg2.png": 44656,
	"./body/archer/leg3.png": 75585,
	"./body/archer/leg4.png": 9879,
	"./body/barbarian/bhand1.png": 18561,
	"./body/barbarian/bhand2.png": 91213,
	"./body/barbarian/body.png": 57654,
	"./body/barbarian/fhand1.png": 55223,
	"./body/barbarian/fhand2.png": 45725,
	"./body/barbarian/leg1.png": 16331,
	"./body/barbarian/leg2.png": 28771,
	"./body/barbarian/leg3.png": 6947,
	"./body/barbarian/leg4.png": 57465,
	"./body/crusade/bhand1.png": 61343,
	"./body/crusade/bhand2.png": 58776,
	"./body/crusade/body.png": 76287,
	"./body/crusade/fhand1.png": 64229,
	"./body/crusade/fhand2.png": 46103,
	"./body/crusade/leg1.png": 26612,
	"./body/crusade/leg2.png": 69966,
	"./body/crusade/leg3.png": 26610,
	"./body/crusade/leg4.png": 22449,
	"./body/dancer/bhand1.png": 76915,
	"./body/dancer/bhand2.png": 69492,
	"./body/dancer/body.png": 59976,
	"./body/dancer/fhand1.png": 99312,
	"./body/dancer/fhand2.png": 54414,
	"./body/dancer/leg1.png": 6768,
	"./body/dancer/leg2.png": 37563,
	"./body/dancer/leg3.png": 49374,
	"./body/dancer/leg4.png": 43071,
	"./body/folk/bhand1.png": 27248,
	"./body/folk/bhand2.png": 60081,
	"./body/folk/body.png": 22094,
	"./body/folk/fhand1.png": 56720,
	"./body/folk/fhand2.png": 71710,
	"./body/folk/leg1.png": 78298,
	"./body/folk/leg2.png": 32284,
	"./body/folk/leg3.png": 78944,
	"./body/folk/leg4.png": 40202,
	"./body/knight(lady)/bhand1.png": 7612,
	"./body/knight(lady)/bhand2.png": 70181,
	"./body/knight(lady)/body.png": 96010,
	"./body/knight(lady)/fhand1.png": 68005,
	"./body/knight(lady)/fhand2.png": 62160,
	"./body/knight(lady)/leg1.png": 26219,
	"./body/knight(lady)/leg2.png": 93064,
	"./body/knight(lady)/leg3.png": 8497,
	"./body/knight(lady)/leg4.png": 25114,
	"./body/knight/bhand1.png": 58692,
	"./body/knight/bhand2.png": 39128,
	"./body/knight/body.png": 54800,
	"./body/knight/fhand1.png": 2005,
	"./body/knight/fhand2.png": 71581,
	"./body/knight/leg1.png": 41241,
	"./body/knight/leg2.png": 79179,
	"./body/knight/leg3.png": 63925,
	"./body/knight/leg4.png": 1142,
	"./body/lady/bhand1.png": 23296,
	"./body/lady/bhand2.png": 65413,
	"./body/lady/body.png": 6348,
	"./body/lady/fhand1.png": 53823,
	"./body/lady/fhand2.png": 92274,
	"./body/lady/leg.png": 71287,
	"./body/lady/leg1.png": 534,
	"./body/lady/leg2.png": 66808,
	"./body/lady/leg3.png": 79733,
	"./body/lady/leg4.png": 2550,
	"./body/mage/bhand1.png": 54780,
	"./body/mage/bhand2.png": 59542,
	"./body/mage/body.png": 94068,
	"./body/mage/fhand1.png": 66122,
	"./body/mage/fhand2.png": 80597,
	"./body/mage/leg1.png": 80179,
	"./body/mage/leg2.png": 3026,
	"./body/mage/leg3.png": 26184,
	"./body/mage/leg4.png": 7922,
	"./body/merchant/bhand1.png": 8936,
	"./body/merchant/bhand2.png": 39486,
	"./body/merchant/body.png": 9751,
	"./body/merchant/fhand1.png": 84434,
	"./body/merchant/fhand2.png": 37005,
	"./body/merchant/leg1.png": 40317,
	"./body/merchant/leg2.png": 48473,
	"./body/merchant/leg3.png": 60704,
	"./body/merchant/leg4.png": 7885,
	"./body/monk/bhand1.png": 48837,
	"./body/monk/bhand2.png": 70725,
	"./body/monk/body.png": 93655,
	"./body/monk/fhand1.png": 66426,
	"./body/monk/fhand2.png": 32553,
	"./body/monk/leg1.png": 14716,
	"./body/monk/leg2.png": 19656,
	"./body/monk/leg3.png": 63163,
	"./body/monk/leg4.png": 48502,
	"./body/musketeer/bhand1.png": 35620,
	"./body/musketeer/bhand2.png": 82762,
	"./body/musketeer/body.png": 78232,
	"./body/musketeer/fhand1.png": 82505,
	"./body/musketeer/fhand2.png": 89889,
	"./body/musketeer/leg1.png": 48453,
	"./body/musketeer/leg2.png": 92893,
	"./body/musketeer/leg3.png": 62240,
	"./body/musketeer/leg4.png": 3465,
	"./body/ninja/bhand1.png": 95373,
	"./body/ninja/bhand2.png": 47711,
	"./body/ninja/body.png": 80889,
	"./body/ninja/fhand1.png": 2390,
	"./body/ninja/fhand2.png": 34579,
	"./body/ninja/leg1.png": 63078,
	"./body/ninja/leg2.png": 94730,
	"./body/ninja/leg3.png": 71418,
	"./body/ninja/leg4.png": 59959,
	"./body/nude/bhand1.png": 56008,
	"./body/nude/bhand2.png": 43086,
	"./body/nude/body.png": 70260,
	"./body/nude/fhand1.png": 43284,
	"./body/nude/fhand2.png": 62029,
	"./body/nude/head.png": 49547,
	"./body/nude/leg1.png": 24882,
	"./body/nude/leg2.png": 80218,
	"./body/nude/leg3.png": 51222,
	"./body/nude/leg4.png": 68401,
	"./body/nun/bhand1.png": 48840,
	"./body/nun/bhand2.png": 15503,
	"./body/nun/body.png": 28288,
	"./body/nun/fhand1.png": 20549,
	"./body/nun/fhand2.png": 31932,
	"./body/nun/leg1.png": 87293,
	"./body/nun/leg2.png": 90472,
	"./body/nun/leg3.png": 14989,
	"./body/nun/leg4.png": 57557,
	"./body/peasant/bhand1.png": 15742,
	"./body/peasant/bhand2.png": 11663,
	"./body/peasant/body.png": 42645,
	"./body/peasant/fhand1.png": 19153,
	"./body/peasant/fhand2.png": 90783,
	"./body/peasant/leg1.png": 99962,
	"./body/peasant/leg2.png": 25494,
	"./body/peasant/leg3.png": 76342,
	"./body/peasant/leg4.png": 22413,
	"./body/priest/bhand1.png": 61117,
	"./body/priest/bhand2.png": 23443,
	"./body/priest/body.png": 85719,
	"./body/priest/fhand1.png": 75801,
	"./body/priest/fhand2.png": 49246,
	"./body/priest/leg1.png": 34094,
	"./body/priest/leg2.png": 74180,
	"./body/priest/leg3.png": 17555,
	"./body/priest/leg4.png": 62096,
	"./body/samurai/bhand1.png": 90531,
	"./body/samurai/bhand2.png": 9318,
	"./body/samurai/body.png": 70178,
	"./body/samurai/fhand1.png": 89545,
	"./body/samurai/fhand2.png": 57435,
	"./body/samurai/leg1.png": 86541,
	"./body/samurai/leg2.png": 74983,
	"./body/samurai/leg3.png": 49964,
	"./body/samurai/leg4.png": 51065,
	"./body/thief/bhand1.png": 19514,
	"./body/thief/bhand2.png": 28726,
	"./body/thief/body.png": 32497,
	"./body/thief/fhand1.png": 59450,
	"./body/thief/fhand2.png": 49615,
	"./body/thief/leg1.png": 61453,
	"./body/thief/leg2.png": 38928,
	"./body/thief/leg3.png": 85242,
	"./body/thief/leg4.png": 14341,
	"./body/witch/bhand1.png": 40239,
	"./body/witch/bhand2.png": 84088,
	"./body/witch/body.png": 9821,
	"./body/witch/fhand1.png": 47453,
	"./body/witch/fhand2.png": 34861,
	"./body/witch/leg1.png": 1374,
	"./body/witch/leg2.png": 69905,
	"./body/witch/leg3.png": 27584,
	"./body/witch/leg4.png": 84433,
	"./body/wizard/bhand1.png": 72369,
	"./body/wizard/bhand2.png": 81978,
	"./body/wizard/body.png": 19482,
	"./body/wizard/fhand1.png": 36439,
	"./body/wizard/fhand2.png": 58904,
	"./body/wizard/leg1.png": 6117,
	"./body/wizard/leg2.png": 53824,
	"./body/wizard/leg3.png": 15002,
	"./body/wizard/leg4.png": 47750,
	"./face0-1.png": 23728,
	"./face0-2.png": 73613,
	"./face0-3.png": 99577,
	"./face0-4.png": 62010,
	"./face1-1.png": 24367,
	"./face1-2.png": 52458,
	"./face1-3.png": 12351,
	"./face1-4.png": 3646,
	"./face10-1.png": 56179,
	"./face10-2.png": 13748,
	"./face10-3.png": 49071,
	"./face10-4.png": 70328,
	"./face11-1.png": 31878,
	"./face11-2.png": 7381,
	"./face11-3.png": 16443,
	"./face11-4.png": 963,
	"./face12-1.png": 11228,
	"./face12-2.png": 62764,
	"./face12-3.png": 64735,
	"./face12-4.png": 86252,
	"./face13-1.png": 26589,
	"./face13-2.png": 16558,
	"./face13-3.png": 20286,
	"./face13-4.png": 82352,
	"./face14-1.png": 72965,
	"./face14-2.png": 9350,
	"./face14-3.png": 28476,
	"./face14-4.png": 48593,
	"./face15-1.png": 43262,
	"./face15-2.png": 80934,
	"./face15-3.png": 6009,
	"./face15-4.png": 51555,
	"./face2-1.png": 53277,
	"./face2-2.png": 44409,
	"./face2-3.png": 33492,
	"./face2-4.png": 99729,
	"./face3-1.png": 26396,
	"./face3-2.png": 64170,
	"./face3-3.png": 86996,
	"./face3-4.png": 83390,
	"./face4-1.png": 90398,
	"./face4-2.png": 16385,
	"./face4-3.png": 14737,
	"./face4-4.png": 24613,
	"./face5-1.png": 92567,
	"./face5-2.png": 19337,
	"./face5-3.png": 36442,
	"./face5-4.png": 79936,
	"./face6-1.png": 42599,
	"./face6-2.png": 228,
	"./face6-3.png": 40553,
	"./face6-4.png": 5643,
	"./face7-1.png": 43150,
	"./face7-2.png": 25807,
	"./face7-3.png": 1910,
	"./face7-4.png": 33651,
	"./face8-1.png": 91418,
	"./face8-2.png": 90872,
	"./face8-3.png": 78231,
	"./face8-4.png": 12997,
	"./face9-1.png": 63407,
	"./face9-2.png": 24563,
	"./face9-3.png": 99215,
	"./face9-4.png": 84549,
	"./facebg.png": 48831,
	"./hair00.png": 89225,
	"./hair01.png": 56053,
	"./hair02.png": 64866,
	"./hair03.png": 42577,
	"./hair04.png": 53846,
	"./hair05.png": 48019,
	"./hair06.png": 58181,
	"./hair07.png": 27284,
	"./hair08.png": 87904,
	"./hair09.png": 2695,
	"./hair10.png": 21263,
	"./hair11.png": 38789,
	"./hair12.png": 84580,
	"./hair13.png": 33691,
	"./hair14.png": 94389,
	"./hair15.png": 73422,
	"./hat01.png": 56836,
	"./hat02.png": 24078,
	"./hat03.png": 13717,
	"./hat04.png": 46796,
	"./hat05.png": 35094,
	"./hat06.png": 4295,
	"./hat07.png": 63827,
	"./hat08.png": 24844,
	"./hat09.png": 59693,
	"./hat10.png": 57182,
	"./hat11.png": 30153,
	"./hat12.png": 3768,
	"./hat13.png": 57254,
	"./hat14.png": 46186,
	"./hat15.png": 81806,
	"./head.png": 29352,
	"./head_.png": 32675,
	"./icon_m1b71emm34s/huafu.png": 62522,
	"./icon_m1b71emm34s/huafu1.png": 69050,
	"./icon_m1b71emm34s/huafu1_1.png": 51084,
	"./icon_m1b71emm34s/huafu2.png": 43370,
	"./icon_m1b71emm34s/huafu2_1.png": 52887,
	"./neisland_tex.png": 70087,
	"./neisland_texbf.png": 55691,
	"./shangchuan.jpg": 8150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95467;